<div
  class="review-officer-form-entry w-100 d-flex p-3"
  *ngIf="changeRequestThirdPartyFormData">
  <div class="flex-grow-1 mw-70">
    <div
      class="w-100 px-3"
      *ngIf="showDiff && activeThirdPartyFormData; else rawOfficerFormView">
      <irembogov-json-diff-viewer
        sectionTitle="Officer Form Changes"
        [oldData]="activeThirdPartyFormData"
        [newData]="changeRequestThirdPartyFormData"
        viewMode="side-by-side">
      </irembogov-json-diff-viewer>
    </div>
    <ng-template #rawOfficerFormView>
      <div class="w-100 px-3">
        <pre
          class="border bg-white overflow-auto w-100 p-3"
          [innerHTML]="
            changeRequestThirdPartyFormData
              | prettyjson : { escapeHtmlBracket: true }
          "
          *ngIf="changeRequestThirdPartyFormData"></pre>
      </div>
    </ng-template>
  </div>
  <irembogov-reviewer-issues-entry-form-widget
    class="justify-self-end w-30"
    [changeRequestId]="changeRequest.id"
    [reviewSection]="EServiceChangeRequestReviewSection.OFFICER_FORM"
    (goToNext)="
      reviewOfficerFormJsonCompleted.emit($event)
    "></irembogov-reviewer-issues-entry-form-widget>
</div>
